import React from "react";
import { GenericPage } from "../../../../../pages";
import { profilesRoute } from "./options-profile.route";
import { usersRoute } from "./options-user.route";
import { systemRoute } from "./options-system.route";
import { migrationsRoute } from "./options-migrations.route";
import { notificationContactsRoute } from "./options-notification-contact.route";
import { cronsRoute } from "./options-crons.route";
import { backupsRoute } from "./options-backup.route";

export const optionsRoute = [
  {
    path: "crons",
    element: <GenericPage />,
    children: cronsRoute,
  },
  {
    path: "profiles",
    element: <GenericPage />,
    children: profilesRoute,
  },
  {
    path: "notification-contacts",
    element: <GenericPage />,
    children: notificationContactsRoute,
  },
  {
    path: "users",
    element: <GenericPage />,
    children: usersRoute,
  },
  {
    path: "migrations",
    element: <GenericPage />,
    children: migrationsRoute,
  },
  {
    path: "system",
    element: <GenericPage />,
    children: systemRoute,
  },
];
